/**
 * Created by Ivan on 10.08.2026
 */

cleverapps.Tool.stickersBook2 = ToolFolder.create(() => {
    if (!cleverapps.stickersBook2) {
        return;
    }

    const setSeasonShift = function (seasonIndex, year) {
        const now = new DateShift.Date();
        const targetYear = (typeof year === "number") ? year : now.getFullYear();

        const month = seasonIndex * StickersBook2.MONTHS_PER_SEASON;
        const seasonStart = new DateShift.Date(targetYear, month, 2, 0, 0, 0, 0);

        const delta = seasonStart.getTime() - now.getTime();
        DateShift.setShift(delta);
        cleverapps.stickersBook2.updateSeason();
    };

    const createSeasonsFolder = function (year) {
        return ToolFolder.create(() => {
            const seasons = {};
            for (let seasonIndex = 0; seasonIndex < 6; seasonIndex++) {
                const index = seasonIndex;
                seasons[`startSeason${index}`] = () => {
                    setSeasonShift(index, year);
                };
            }
            return seasons;
        });
    };

    const givePacks = {};
    Object.keys(StickersBook2.PACKS).forEach((type) => {
        givePacks[type] = displayToolWindow(() => {
            new RewardWindow({ [type]: 1 }, { event: cleverapps.EVENTS.EARN.OTHER });
        });
    });

    return {
        givePacks: ToolFolder.create(() => givePacks),

        addPoints: function () {
            const amount = parseInt(window.prompt("Enter amount", 10), 10);
            if (amount) {
                cleverapps.stickersBook2.incPoints(amount);
            }
        },

        openAll: function () {
            cleverapps.focusManager.closeAllWindows();
            cleverapps.stickersBook2.collections.forEach((collection) => {
                collection.stickers.forEach((sticker) => {
                    sticker.open();
                    if (StickersBook2.isPuzzle()) {
                        sticker.setAttention(false);
                    }
                });
            });
        },

        clearAll: function () {
            cleverapps.focusManager.closeAllWindows();
            cleverapps.stickersBook2.collections.forEach((collection) => {
                collection.stickers.forEach((sticker) => {
                    sticker.state = Sticker2.STATE_CLOSED;
                    sticker.setAttention(false);
                });

                collection.resetAttention();
                collection.isPrizeCollected = false;
                collection.isCompleted = false;
            });
            cleverapps.stickersBook2.save();
        },

        openSeasonFinishWindow: displayToolWindow(() => new StickersBookSeasonWindow2({ isCompleted: true })),

        openSeasonFinishWindowFallback: displayToolWindow(() => new StickersBookSeasonWindow2({ isCompleted: true, fallback: true })),

        startFeature: () => {
            cleverapps.stickersBook2.setSeason(undefined);
            cleverapps.stickersBook2.updateSeason();
        },

        finish: () => {
            const timeLeft = cleverapps.stickersBook2.getSeasonTimeLeft();
            if (timeLeft === undefined) {
                return;
            }

            const delta = DateShift.getDelta();

            DateShift.setShift(delta + timeLeft);
            cleverapps.stickersBook2.updateSeason();
            DateShift.setShift(delta);
        },

        seasons_2026: createSeasonsFolder(2026),

        seasons_2027: createSeasonsFolder(2027),

        resetToNow: () => {
            DateShift.setShift(0);
            cleverapps.stickersBook2.updateSeason();
        }
    };
});
